import FormFieldComponent from '@/components/FormFieldComponent';
import FormFieldPhone from '@/components/FormFieldPhone';
import { FormFieldSelect } from '@/components/FormFieldSelect';
import {
  ADDRESS_LINE_VALIDATION,
  CITY_VALIDATION,
  FAX_REPLACE_REGEX,
  NAME_VALIDATION,
  STATE_VALIDATION,
  ZIP_CODE_VALIDATION,
} from '@/utils/constant';

import { useFormContext } from 'react-hook-form';

export const ClientInfo = () => {
  const { control, watch, setValue } = useFormContext();
  const type = watch('type') as string;

  return (
    <div className="flex flex-col w-full mt-11 gap-6">
      <div className="flex w-full gap-6 ">
        <div className="w-[20vw]">
          <FormFieldSelect
            name="type"
            label="Client Type"
            placeholder="Client Type"
            options={[
              { label: 'Individual', value: 'INDIVIDUAL' },
              { label: 'Firm', value: 'FIRM' },
            ]}
            required
            onChange={() => {
              setValue('firstName', '');
              setValue('lastName', '');
              setValue('clientName', '');
            }}
          />
        </div>
        {type === 'FIRM' && (
          <div className="w-full">
            <FormFieldComponent
              name="clientName"
              label="Client Name"
              control={control}
              placeholder="Enter Client Name"
              required
              capitalizeFirstLetter
              maxLength={128}
              allowNumber={false}
              replaceRegex={/^[^a-zA-Z]+/}
            />
          </div>
        )}
        {type === 'INDIVIDUAL' && (
          <div className="w-full gap-6 grid grid-cols-2">
            <FormFieldComponent
              name="firstName"
              label="First Name"
              control={control}
              placeholder="Enter First Name"
              required
              {...NAME_VALIDATION}
            />

            <FormFieldComponent
              name="lastName"
              label="Last Name"
              control={control}
              placeholder="Enter Last Name"
              required
              {...NAME_VALIDATION}
            />
          </div>
        )}
      </div>
      <FormFieldComponent
        name="address1"
        label="Address Line 1"
        control={control}
        placeholder="Enter Street Address"
        required
        {...ADDRESS_LINE_VALIDATION}
      />
      <FormFieldComponent
        name="address2"
        label="Address Line 2"
        control={control}
        placeholder="Enter Apt, suite etc. (Optional)"
        {...ADDRESS_LINE_VALIDATION}
      />
      <div className="grid grid-cols-3 gap-6">
        <FormFieldComponent
          name="city"
          label="City"
          control={control}
          placeholder="City"
          required
          {...CITY_VALIDATION}
        />
        <FormFieldComponent
          name="state"
          label="State"
          control={control}
          placeholder="State"
          required
          {...STATE_VALIDATION}
        />
        <FormFieldComponent
          name="zipCode"
          label="Zip Code"
          control={control}
          placeholder="Zip Code"
          required
          {...ZIP_CODE_VALIDATION}
        />
      </div>
      <div className="grid grid-cols-3 gap-6">
        <FormFieldPhone name="phone" label="Phone Number" defaultCountry="us" />
        <FormFieldComponent
          name="fax"
          label="Fax"
          control={control}
          placeholder="Enter Fax"
          replaceRegex={FAX_REPLACE_REGEX}
        />
        <FormFieldComponent name="website" label="Web Address" control={control} placeholder="Enter Web Address" />
      </div>
    </div>
  );
};
